import { Col, Row, Table } from 'antd';
import { Document } from '@react-pdf/renderer';
import './printExpectedResult.scss';
import { calculateTotalOfUnits } from 'utils/calculateTotalOfUoms';
import moment from 'moment';

const table = {
  columns: () => [{
    title: 'UOM',
    dataIndex: 'uom',
    width: '177px',
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    width: '177px',
  },
  {
    title: 'Contains',
    dataIndex: 'contains',
    width: '177px',
  }],

  data: (data) => data.map((item) => ({
    key: item.id,
    uom: item.carton_id
      ? typeof item.carton_id !== 'boolean' ? 'M Carton' : 'Carton'
      : 'Each',
    quantity: item.quantity,
    contains: item.contains || 1,
  })),
};

export function ExpectedPDF(props) {
  const { order, stores, orderItems } = props;
  const store = stores.find((elem) => elem.id === order.store_id);

  const summaryRow = (dataTable) => (
    <Table.Summary.Row>
      <Table.Summary.Cell index={0} colSpan={2}>
        <span className="bold">TOTAL</span>
        (Eaches):
      </Table.Summary.Cell>
      <Table.Summary.Cell index={1} colSpan={1}>
        {calculateTotalOfUnits(dataTable)}
      </Table.Summary.Cell>
    </Table.Summary.Row>
  );

  const timeRefactor = (time) => (time ? moment(time).format('MM.DD.YYYY') : '');
  const externalInfo = (data) => {
    const dataExternal = data?.find((elem) => (elem.default === 1));
    return (
      <span>
        {dataExternal.external_id_type_id.name}
        :
        {' '}
        {dataExternal.external_id_value}
      </span>
    );
  };

  return (
    <Document>
      <div className="root-report-order-inbound">
        <div className="header">
          Inbound order
        </div>
        <Row justify="space-between" className="time-block">
          <div>
            Status:
            {' '}
            {order.status}
          </div>
          <div>
            Date:
            {' '}
            {timeRefactor(new Date())}
          </div>
        </Row>
        <div className="header-inbound">
          <Row className="row-header-info">
            <Col span={12}>
              <Row>
                <Col span={12}>Number:</Col>
                <Col span={12} className="bold">{order.id}</Col>
              </Row>
              <Row>
                <Col span={12}>Date expected:</Col>
                <Col span={12} className="bold">{timeRefactor(order.expected)}</Col>
              </Row>

              <Row>
                <Col span={12}>Store:</Col>
                <Col span={12} className="bold">{store.company_name}</Col>
              </Row>
            </Col>

            <Col span={12}>
              <Row>
                <Col span={12}>Ship to:</Col>
              </Row>
              <Row>
                <Col span={12}>Tracking number:</Col>
                <Col span={12} className="bold">{order.tracking_number}</Col>
              </Row>
            </Col>
          </Row>

          <Row className="row-header-note">
            Note:
            {' '}
            {order.notes}
          </Row>
        </div>

        <div>
          {
            orderItems.map((elem) => (
              <div className="table-block">
                <Row className="table-header">
                  <Col span={24} className="table-item-info">
                    <div className="item-info">
                      {elem.item.external_ids.length
                        ? externalInfo(elem.item.external_ids)
                        : 'ID: Not defined'}
                    </div>

                    <div className="item-info">
                      Item:
                      {' '}
                      <span>{elem.item.name}</span>
                    </div>
                  </Col>
                </Row>
                <Table
                  className="table-report-full-table"
                  pagination={false}
                  columns={table.columns()}
                  dataSource={table.data(elem.expected_measurement_units)}
                  bordered
                  summary={summaryRow}

                />
              </div>
            ))
          }
        </div>
      </div>
    </Document>
  );
}
